<template>
	<Avatar
		:pt="{
			root: { style: avatarStyle },
		}"
		:label="firstLetter"
		:image="pic"
		:size="pSize"
		shape="circle" />
</template>

<script setup>
import { computed } from "vue"
import Avatar from "primevue/avatar"

const props = defineProps({
	pAvatarUrl: { type: String },
	pSize: { type: String, default: "" },
	pName: { type: String, default: "" },
})

const avatarStyle = computed(() => {
	if (props.pSize === "small") return { width: "32px", height: "32px" }
	else if (props.pSize === "mid") return { width: "40px", height: "40px" }
	else if (props.pSize === "large") return { width: "100px", height: "100px" }
	else if (props.pSize === "xlarge") return { width: "120px", height: "120px" }
})

const pic = computed(() => {
	return props.pAvatarUrl
})
const firstLetter = computed(() => {
	if (!pic.value) {
		//must pass pName into customAvatar to prevent error
		return props.pName[0].toUpperCase()
	}
})
</script>

<style scoped>
.p-avatar {
	background-color: #efefef;
	border-radius:50%;
}
:deep(img) {
	object-fit: cover;
}
</style>
